import { Stack } from "@mui/material";
import { useEffect, useState } from "react";
import {
    currentShortExpirationLongConfig,
    expirationShortCurrentLongConfig,
    PortfolioBalancer
} from "../../components/portfolio-balancer/PortfolioBalancer";
import { PortfolioBalancerItemModel } from "../../components/portfolio-balancer/PortfolioBalancerItemModel";
import { PortfolioBalancerToolsPanel } from "../../components/portfolio-balancer/PortfolioBalancerToolsPanel";
import { LineDelimiter } from "../../../positions-and-orders/views";
import { useAppContext } from "../../../../shared/contexts/app-context/components/AppContext";

export function PortfolioBalancerView() {
    const [selectedRow, setSelectedRow] = useState<PortfolioBalancerItemModel | null>(null);
    const {
        setShowBalancerPriceLines,
        setBalancerPriceLineDelta,
    } = useAppContext();

    useEffect(() => {
        return () => {
            setShowBalancerPriceLines(false);
            setBalancerPriceLineDelta(null);
        };
    }, [setShowBalancerPriceLines, setBalancerPriceLineDelta]);

    return (
        <Stack
            direction="column"
            sx={{
                height: '100%',
                overflow: 'hidden',
            }}
        >
            <PortfolioBalancerToolsPanel />
            <LineDelimiter/>
            <PortfolioBalancer
                measurementConfig={currentShortExpirationLongConfig}
                selectedRow={selectedRow}
                setSelectedRow={setSelectedRow}
            />
            <PortfolioBalancer
                measurementConfig={expirationShortCurrentLongConfig}
                selectedRow={selectedRow}
                setSelectedRow={setSelectedRow}
            />
        </Stack>
    );
}
